export const colors = ["#e5eb34","#71eb34", "#eb6e34", "#34deeb", "#3458eb", "#c334eb", "#eb3443"];
